import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import * as React from 'react';

import { LinkableTextArea } from 'components/LinkableTextArea/LinkableTextArea';
import { ProductShape } from 'lib/util/productShape';

import { getWeekdayText } from 'lib/util/getWeekdayText';
import { getScheduleText } from 'components/ProductContentsPane/OperationInfo/OperationInfo';
import { printPriceTitle } from 'lib/util/util';
import { useCurrencyFormatter } from 'hooks/useCurrencyFormatter';

import baseStyles from '../base.module.css';
import styles from './ProductDetailsView.module.css';

type Props = {
  product: ProductShape;
};

export const OperationInfoView = ({ product }: Props) => {
  const { t } = useTranslation();

  const currencyFormatter = useCurrencyFormatter();

  const [selectedPriceScheduleIdx, setSelectedPriceScheduleIdx] = React.useState<number>(0);

  return (
    <section className={clsx(baseStyles['base-column__main__section'])}>
      <div className={clsx(styles['introduction__desc'], 'newline')}>
        <p>
          <LinkableTextArea>{product.description}</LinkableTextArea>
        </p>
      </div>
      {(product.priceSchedules ?? []).length > 0 && (
        <div className="base-marginTop-32">
          <label className={styles['overview__content__item__select']}>
            <select
              name="priceSchedule"
              value={selectedPriceScheduleIdx}
              onChange={(e) => setSelectedPriceScheduleIdx(parseInt(e.target.value))}
            >
              {product.priceSchedules.map((priceSchedule, idx) => (
                <option key={idx} value={idx}>
                  {getScheduleText(priceSchedule, t)}
                </option>
              ))}
            </select>
          </label>
        </div>
      )}
      <div className={styles['introduction']}>
        <ul className={styles['introduction__price']}>
          {product.priceSchedules?.[selectedPriceScheduleIdx]?.prices.map((price) => (
            <li key={price.unitTitle}>
              <p>{printPriceTitle(price, t)}</p>
              <p>{currencyFormatter.format(price.amount)}</p>
            </li>
          ))}
        </ul>
        <ul className={styles['introduction__info']}>
          <li>
            <p>{t('Days of Week')}</p>
            <p>
              {product.operatingWeekdays.map((weekday) => getWeekdayText(weekday, t)).join(',')}
            </p>
          </li>
          <li>
            <p>{t('Duration')}</p>
            <p>
              {t('{{durationInHours}} hours', {
                durationInHours: product.durationInHours,
              })}
            </p>
          </li>
        </ul>
      </div>
    </section>
  );
};
